import { handleError } from "@/utils/error";
import { useClient, useUpdateClient } from "creso-core/hooks";
import { XIcon } from "lucide-react";
import { useEffect, useState } from "react";
import {
  Button,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  V2Dialog,
  V2Input,
  VisuallyHidden,
} from "web-design-system";

export const AddEmail = ({
  id,
  contactEmail,
}: {
  id: number;
  contactEmail: string;
}) => {
  const { mutateAsync: updateClient } = useUpdateClient(Number(id));
  const { data: client } = useClient(Number(id));
  const [email, setEmail] = useState(client?.email ?? contactEmail ?? "");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setEmail(client?.email ?? contactEmail ?? "");
  }, [client, contactEmail]);

  const handleAddEmail = () => {
    updateClient({ ...client, email })
      .then(() => setOpen(false))
      .catch((error) => handleError(error, "Failed to add email"));
  };

  return (
    <V2Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="link"
          className="h-auto px-0 py-1 line-clamp-1 text-ellipsis text-primary justify-start"
        >
          {client?.email || contactEmail || "Add email"}
        </Button>
      </DialogTrigger>
      <DialogContent className="p-4">
        <DialogHeader>
          <VisuallyHidden>
            <DialogTitle>Edit remark</DialogTitle>
            <DialogDescription>Edit remarks dialog</DialogDescription>
          </VisuallyHidden>
          <div className="flex justify-between flex-row items-center">
            <h4>Edit email for {client?.name}</h4>
            <Button variant="ghost" size="icon" onClick={() => setOpen(false)}>
              <XIcon />
            </Button>
          </div>
        </DialogHeader>
        <V2Input value={email} onChange={(e) => setEmail(e.target.value)} />
        <DialogFooter>
          <Button variant="secondary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button onClick={handleAddEmail}>Add</Button>
        </DialogFooter>
      </DialogContent>
    </V2Dialog>
  );
};
